import { COMPANY_NEWS } from '../../constants/CopilotInAppActionTypes';
export const companyNews = action => {
  return {
    data: {
      intent: COMPANY_NEWS,
      domain: action.domain
    },
    text: `Show me news for ${action.domain}`
  };
};